import createAction from 'helpers/createAction';
import { SET_FILTERED_GEOJSON } from 'reducers/reducer';

const handleCropZoneRedirect = ({ geoJsonData, formActions, navigation }) => {
  const {
    createdCropZone,
    allFFTGeoJson,
    updateCropZoneGeoJson,
    dispatch
  } = geoJsonData;
  const { resetForm } = formActions;
  const { redirectToLanding, history, goTo } = navigation;

  if (!redirectToLanding) {
    // Dispatch the updated GeoJSON
    createAction(
      dispatch,
      SET_FILTERED_GEOJSON,
      updateCropZoneGeoJson(createdCropZone, allFFTGeoJson)
    );
  }

  resetForm();

  if (redirectToLanding) {
    history.push(goTo.current);
    window.location.reload();
  }
};

export default handleCropZoneRedirect;
